import {IToolsService} from "./tools.service.interface";
import {ServiceBase} from "../ServiceBase";
import { v4 as uuidv4 } from 'uuid';

export class ToolsService extends ServiceBase implements IToolsService{
    getGuid(): string {
      return uuidv4();
    }

    isGuid(testedValue: string): boolean {
        return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(testedValue);
    }
}